import { PfcPieChart } from './PfcPieChart.ts';

document.addEventListener('DOMContentLoaded', () => {
    // --- 1. ターゲット要素の取得 (新仕様: Role属性ベース) ---
    // data-chart-role="container" かつ data-chart-type="pfc-pie-chart" の要素を検索
    const chartWrappers = document.querySelectorAll('[data-chart-role="container"][data-chart-type="pfc-pie-chart"]');

    chartWrappers.forEach(wrapper => {
        // --- 2. 内部要素の取得 (新仕様: Role属性ベース) ---
        const chartArea = wrapper.querySelector('[data-chart-role="chart-area"]');
        const controlsContainer = wrapper.querySelector('[data-chart-role="controls"]'); // フッターコントロール

        if (!chartArea || !controlsContainer) {
            console.error('[pfc-pie-chart] Error: Required DOM elements (role=chart-area/controls) not found.');
            return;
        }

        // 二重初期化防止
        if (chartArea._chartInstance) {
            return;
        }

        // --- 3. グラフインスタンスの生成 ---
        console.log('[pfc-pie-chart] Creating instance...');
        const chart = new PfcPieChart(chartArea, {});
        chartArea._chartInstance = chart;
        chartArea.dataset.chartInstance = 'true';

        // --- 4. 非同期初期化とUIセットアップ ---
        chart.init().then(() => {
            // 4a. 必要なデータ属性の取得 (HTML側で設定されている)
            // options: "ラベル1:キー1, ラベル2:キー2" 形式
            const optionsStr = chartArea.dataset.options;
            const initialKey = chartArea.dataset.initialKey;

            if (!optionsStr || !initialKey) {
                console.warn('[pfc-pie-chart] Warning: Required data attributes (options/initialKey) are missing.');
                return;
            }

            // 4b. UI要素（ラジオボタン）の動的生成
            // ユニークなグループ名を作成 (IDベース)
            const radioGroupName = `pfc-data-type-${chartArea.id}`;
            
            const optionsHtml = optionsStr.split(',')
                .map(pair => {
                    const [label, value] = pair.split(':').map(s => s.trim());
                    if (!label || !value) return '';

                    const isChecked = value === initialKey ? 'checked' : '';
                    return `
                        <label>
                            <input type="radio" name="${radioGroupName}" value="${value}" ${isChecked}>
                            <span>${label}</span>
                        </label>
                    `;
                })
                .join('');
            
            controlsContainer.innerHTML = optionsHtml;
            
            // 4c. イベントリスナーを設定
            controlsContainer.addEventListener('change', (event) => {
                if (event.target.type === 'radio') {
                    const selectedKey = event.target.value;
                    console.log(`[pfc-pie-chart] Switching to: ${selectedKey}`);
                    chart.updateByKey(selectedKey);
                }
            });
            
            // 4d. 描画クラスからの状態変更をUIに反映 (アニメーション中の操作無効化)
            const setControlsDisabled = (disabled) => {
                controlsContainer.querySelectorAll('input[type="radio"]').forEach(radio => {
                    radio.disabled = disabled;
                });
                // スタイル制御用のクラスを付け替え
                controlsContainer.classList.toggle('is-disabled', disabled);
            };

            // 描画クラスのイベントフック
            chart.on('animationStart', () => setControlsDisabled(true));
            chart.on('animationEnd', () => setControlsDisabled(false));

        }).catch(error => {
            // --- 5. エラーハンドリング ---
            console.error('[pfc-pie-chart] Initialization failed:', error);
        });
    });
});